<div class="flex flex-column align-items-center">
  <h1 class="mb-4 text-center">{{ 'PD_COLLECT_DATA.HEADER.SUCCESS' | translate }}</h1>
  <p class="mb-3 text-center">{{ 'PD_COLLECT_DATA.TEXT.REQUEST_PROCESSED' | translate }}</p>
  <p class="mb-3 text-center">{{ 'PD_COLLECT_DATA.TEXT.START_ENJOYING' | translate }}</p>
  <p class="mb-3 text-center">{{ 'PD_COLLECT_DATA.TEXT.QUESTION_EMAIL' | translate }}</p>
  <object type="image/svg+xml" data="../../../../../assets/images/success.svg"></object>

  <button *ngIf="showProceedButton" pButton pRipple class="simple-button mt-4 md:w-9" (click)="redirectHome()">
    {{ 'PD_COLLECT_DATA.LABEL.RETURN_HOME' | translate }}
  </button>
</div>
